export enum LegalityDeclarationMethodEnum {
  SIMPLE = 'simple',
  DETAILED = 'detailed',
  FILE_UPLOAD = 'file_upload'
}
